<template lang="pug">
uc-filter-tags(v-slot="{ filterTags }")
  uc-scroll-section(
    :data-pass-course="1"
    :id="screen.id"
    :key="screen.id"
    v-for="screen in filterTags(patchedScreens)"
  )
    uc-screen(:screen="screen")
</template>

<script setup lang="ts">
import { inject, computed, unref } from 'vue';
// import useSuspend from '../lib/useSuspend';

const props = defineProps<{ page: { screens: UcScreen[] } }>();

const content = inject('content');

const patchedScreens = computed(() => {
  const defaultScreens = props.page.screens;

  const { patches } = unref(content);

  console.log({ patches });

  return patches?.screens
    ? defaultScreens.map(screen => {
        const p = patches.screens[screen.id];

        console.log(JSON.stringify(p));

        return p ? p[0] : screen;
      })
    : defaultScreens;
});
</script>
